/**
 * Main dashboard layout with sidebar navigation and header
 */

import { Outlet } from 'react-router-dom';
import { useStore } from '@/store';
import { DashboardHeader, DesktopSidebar, MobileSidebar } from './dashboard';
import { cn } from '@/lib/utils';

/**
 * Main layout component for the dashboard
 */
export function DashboardLayout() {
  const sidebarState = useStore((state) => state.sidebarState);
  const isCollapsed = sidebarState === 'collapsed';

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <DashboardHeader />
      <DesktopSidebar />
      <MobileSidebar />

      {/* Main content */}
      <main
        className={cn('pt-16 transition-all duration-200', isCollapsed ? 'lg:pl-16' : 'lg:pl-60')}
      >
        <div className="px-4 py-8 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
